module.exports = __webpack_public_path__ + "static/og-51e79f1c43a76bc23da26dd0f930c58c.png";